import styled, { css } from 'styled-components';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import React from 'react';

export default class Required extends React.PureComponent {
  render() {
    return <Red {...this.props}>*</Red>;
  }
}

const Red = styled.span`
  color: ${colors.darkRed};

  ${(props) =>
    props.withLeftPadding &&
    css`
      padding-left: 4px;
    `}
`;
